export class DrawerState {
  isOpen: boolean = false;
  data: DrawerData = { title: "", overview: {}, details: {} };
}

export interface DrawerFields {
  title: string;
  transformTitle?: any,
  overview?: { [key: string]: DrawerField; };
  details?: { [key: string]: DrawerField; };
}

interface DrawerField {
  key: string,
  transform?: (value: any, row: any) => string,
  expandable?: boolean,
  asHTML?: boolean
}

export interface DrawerData {
  title: string;
  overview: { [key: string]: any; };
  details: { [key: string]: any; };
}
